import firebase from 'firebase/app';
import 'firebase/messaging';

let cachedTokenPromise = null;

export const initializeFirebase = () => {
  firebase.initializeApp({
    apiKey: "AIzaSyCOZ_MS_gPcP0OTVYdY44DcogLZ1KcaZSk",
    authDomain: "trackerboerenijsjebe.firebaseapp.com",
    projectId: "trackerboerenijsjebe",
    storageBucket: "trackerboerenijsjebe.firebasestorage.app",
    messagingSenderId: "665962462557",
    appId: "1:665962462557:web:6f068b10bbe290d2e6fcb4"
  });

  // Pre-warm: if permission already granted, get token in background
  if (Notification.permission === 'granted' && 'serviceWorker' in navigator && !window.__nativePushToken) {
    cachedTokenPromise = navigator.serviceWorker.ready.then(swReg =>
      firebase.messaging().getToken({
        vapidKey: "BPj4SGupOQXzLVMXbuWrdJ5r-ylXnOGp9pDpCImVoHZH1U1o6SR2ggow1Gldza0j7_26M6NNyIgL7DO2GkuvBQ4",
        serviceWorkerRegistration: swReg
      })
    ).catch(() => null);
  }
}

export const askForPermissionToReceiveNotifications = async () => {
    // If running inside the native iOS app, use the native push token
    // injected by AppDelegate instead of requesting a web push token.
    if (window.__nativePushToken) {
        console.info("[Firebase] Using native iOS push token");
        localStorage.setItem("fcm_token", window.__nativePushToken);
        return { status: "SUCCESS", token: window.__nativePushToken };
    }
    if (window.webkit?.messageHandlers?.nativePush) {
        console.info("[Firebase] Native iOS app detected, waiting for token...");
        const token = await new Promise((resolve) => {
            let attempts = 0;
            const check = setInterval(() => {
                if (window.__nativePushToken) {
                    clearInterval(check);
                    resolve(window.__nativePushToken);
                } else if (++attempts >= 50) {
                    clearInterval(check);
                    resolve(localStorage.getItem("fcm_token") || null);
                }
            }, 100);
        });
        if (token) {
            console.info("[Firebase] Got native iOS push token after waiting");
            localStorage.setItem("fcm_token", token);
            return { status: "SUCCESS", token: token };
        }
        console.warn("[Firebase] Native iOS app but no token available");
    }
  try {
    const messaging = firebase.messaging();

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      return ({ status: "FAIL", error: "Notification permission denied" });
    }
    let token;
    if (cachedTokenPromise) {
      token = await cachedTokenPromise;
    }
    if (!token) {
      const swReg = await navigator.serviceWorker.ready;
      token = await messaging.getToken({
        vapidKey: "BPj4SGupOQXzLVMXbuWrdJ5r-ylXnOGp9pDpCImVoHZH1U1o6SR2ggow1Gldza0j7_26M6NNyIgL7DO2GkuvBQ4",
        serviceWorkerRegistration: swReg
      });
    }
    return ({
      status: "SUCCESS",
      token: token
    });
  } catch (error) {
    return ({
      status: "FAIL",
      error: error
    });
  }
}
